import React from 'react'
import { ProductItemContextType } from './types'
import { langMap } from './lang'

export const ProductItemContext = React.createContext<ProductItemContextType>({
  moneySymbol: 'HK$',
  btnStatusMap: langMap.en.btnStatus,
  tabItem: undefined,
})
